<router-outlet></router-outlet>
<mg-spinner></mg-spinner>
